/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { useMemo } from "react";
import { isFullyWrappedInAnchor } from "./TitleDescStack.molecule";
import { hasContent } from "@components/elements/atoms";
import type { CosmosVariableRichText } from "@components/elements/atoms";
import { LinkTitle } from "./LinkTitle.molecule";
import { ColorfulTitle } from "./ColorfulTitle.molecule";
import type { CosmosEnumEdsGradients } from "@cosmos/hygraph-schema";

export interface TitleStackProps {
	title?: CosmosVariableRichText | null;
	gradient?: CosmosEnumEdsGradients | null;
	className?: string;
}

export const TitleStack = ({ title, gradient, className }: TitleStackProps): React.JSX.Element | null => {
	const shouldUseLinkTitle = useMemo(() => isFullyWrappedInAnchor(title), [title]);

	if (!hasContent(title)) return null;

	if (shouldUseLinkTitle) return <LinkTitle gradient={gradient} title={title} className={className} />;

	return <ColorfulTitle gradient={gradient} title={title} className={className} />;
};
